// src/utils/orientation.ts
function dimensionsToOrientation(width, height) {
  if (!width || !height || width === height) {
    return void 0;
  }
  return width > height ? "landscape" /* Landscape */ : "portrait" /* Portrait */;
}

// src/utils/fetch.ts
function fetchText(url, options) {
  return new Promise((resolve, reject) => {
    let timeoutId;
    if (options?.timeout !== void 0) {
      timeoutId = setTimeout(() => {
        reject(new Error(`Request to ${url} timed out (${options.timeout} ms).`));
      }, options.timeout);
    }
    fetch(url, { signal: options?.signal }).then((response) => {
      if (!response.ok) {
        throw new Error(`Request to ${url} returned unexpected status: ${response.status}`);
      }
      return response.text();
    }).then((data) => {
      timeoutId && clearTimeout(timeoutId);
      resolve(data);
    }).catch((e) => {
      timeoutId && clearTimeout(timeoutId);
      reject(e);
    });
  });
}

export {
  dimensionsToOrientation,
  fetchText
};
